import React from 'react';
import './browse_packages.less';
import ReactDOM from 'react-dom';
import InputRange from 'react-input-range';
import './range.less';

import authActions from '../auth/auth_actions';
import browsePackagesAction from './browser_packages_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {commonFunctions} from './browser_common';

import DashBoardHeader from '../header_dashboard/dashboard_header';
import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';

class BrowsePackages extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      userLattitude: 0,
      userLongitude: 0
    }
  }

  getRangeValue(value){
    console.log('range' + value);
    this.setState({value: value})
  }


  componentDidMount(){

  }



  render(){

    const self = this;
    const {props, state} = this;
    let sessionValid = true ;


    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid

    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }

    return(
      <div id="broswePackagesWrap">
        <div id="broswePackages">
          <DashBoardHeader user = {user} logout={this.logout}/>
          <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
            {this.props.children}
            {state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        </div>
        {/*<LoggedinFooter />*/}

      </div>
    )
  }
}

BrowsePackages = connect((state) => {
  return {
    authState: state.app.auth,
    browsePackages: state.app.browsePackages
  }
}, (dispatch) => {
  return {
    authActions : bindActionCreators(authActions, dispatch),
    browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
  }
})(BrowsePackages);

export default BrowsePackages;



// WEBPACK FOOTER //
// app/browse_packages/browse_packages.jsx